// @ts-nocheck
import React from "react";
import { FaChevronRight } from "react-icons/fa";
import {useNavigate } from "react-router-dom";
import Moment from 'react-moment';
import { useDisclosure } from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
} from "@chakra-ui/react";
import { useState } from "react";
import { PostApi } from "../../../../ApiClient/PostApi";
import { error_toaster, success_toaster } from "../../../toaster/Toaster";
export default function IncompleteOrder(props) {
  const navigate = useNavigate();
  const {
    isOpen: IncompleteOpen,
    onOpen: IncompleteOnOpen,
    onClose: IncompleteOnClose,
  } = useDisclosure();

  const [id, setId] = useState("");

  const cancel_order_open = (id) => {
    setId(id);
    IncompleteOnOpen();
  }


  const complete_order = () => {
    localStorage.setItem('orderId', props.orderNo);
    navigate(`${props.button2}`);
  }
  const review_order = (id) => {
    navigate("/reviews", { state: { bookingId: id } })
  }
  const cancel_order_post = async () => {
    const res = await PostApi("booking/cancel_order", {
      bookingId: id
    });
    if (res.data.status === "1") {
      success_toaster(res.data.message);
      setId("");
      IncompleteOnClose();
      window.location.reload(false);
    }
    else {
      error_toaster(res.data.message);
      IncompleteOnClose();
    }

  }
  return (
    <>
      <div className="bg-white rounded-md py-5 sm:px-6 px-3 sm:space-y-3 space-y-2">
        <div className="flex sm:flex-row flex-col justify-between items-center">
          <h1 className="font-medium text-2xl text-themeRed">
            Order#{props.orderNo}
          </h1>
          <button onClick={() => cancel_order_open(props.orderNo)} className="font-normal text-xl text-black text-opacity-60 underline">
            Cancel Order
          </button>
        </div>
        <h1 className="font-medium text-2xl sm:text-start text-center">
          {props.steps} Steps Left
        </h1>
        <p className="font-normal text-base text-black text-opacity-60 sm:text-start text-center">
          Started at <Moment format="D MMM , YYYY hh:mm a">
            {props.time}
          </Moment>
        </p>
        <div className="flex sm:flex-row flex-col gap-y-2 justify-between items-center">
          <button
            onClick={() => review_order(props.orderNo)}
            className="flex items-center gap-x-2 bg-themeYellowLight border border-themeYellow rounded w-fit px-2 py-1"
          >
            <div>
              <img
                src="images/dashboard/review.webp"
                alt="review"
                className="w-6"
              />
            </div>
            <span className="font-normal text-sm underline">Notes</span>
            <div
              className="font-normal text-xs text-white bg-themeYellow w-5 h-5 flex 
              justify-center items-center rounded-fullest"
            >
              <span>{props.reviews}</span>
            </div>
          </button>
          <button
            onClick={complete_order}
            className="font-medium text-xl text-themeRed bg-themeRed2Light py-2 px-4 
            flex items-center gap-x-2"
          >
            <span>Complete Order</span>
            <FaChevronRight />
          </button>
        </div>
      </div>


      <Modal
        size="lg"
        isOpen={IncompleteOpen}
        onClose={IncompleteOnClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Cancel Order</ModalHeader>

          <ModalCloseButton />


          <ModalBody>
            <div className="flex gap-x-2">
              Do you want to cancel your order?

            </div>
          </ModalBody>

          <ModalFooter>
            <div className="space-x-2">
              <button
                className="py-1 w-[100px] border border-themeBlue text-themeBlue rounded-lg"
                onClick={IncompleteOnClose}
              >
                No
              </button>

              <button
                className="py-1 w-[100px] border bg-themeBlue border-themeBlue text-white rounded-lg"
                onClick={cancel_order_post}
              >
                Yes
              </button>


            </div>
          </ModalFooter>



        </ModalContent>
      </Modal>
    </>
  );
}
